import moment from "moment";
import axios from "axios";
import * as Logger from "./Logger";
import React, { useState } from 'react'
import { Context } from "./ContextProvider"


export function secToMin(sec) {
    const sec_num = parseInt(sec, 10); // don't forget the second param
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10 && hours > 0) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    return (hours > 0 ? hours + " h" : "") + minutes + " m";
}

export function meterToKm(meters) {
    return Math.round(meters) / 1000;
}

export function grToPln(getMatchedCSSRules) {
    return (Math.round(getMatchedCSSRules) / 100).toFixed(2);
}

export function toExponential(no) {
    if (no) {
        return no.toExponential(2);
    }
}

export function secondsToTime(seconds) {
    var date = new Date(seconds);
    var hours = date.getHours();
    var minutes = "0" + date.getMinutes();
    var seconds = "0" + date.getSeconds();

    var formattedTime = hours + ':' + minutes.substr(-2);

    return formattedTime;
}

export function roundTo1Decimal(number) {
    return Math.round(number * 10) / 10;
}

export function roundTo0Decimal(number) {
    return Math.round(number);
}

export function latLngToString(latlng) {
    return "" + latlng.lat + "," + latlng.lng
}

export function getDateTimeString() {
    var today = new Date();
    var dd = today.getDate();
    var MM = today.getMonth() + 1; //January is 0!
    var hh = today.getHours();
    var mm = today.getMinutes();
    if (dd < 10) {
        dd = '0' + dd
    }
    if (MM < 10) {
        MM = '0' + MM
    }
    if (mm < 10) {
        hh = '0' + mm
    }
    if (mm < 10) {
        mm = '0' + mm
    }
    return '' + MM + '.' + dd + '_' + hh + '.' + mm;
}

export function getNow() {
    return moment().format("YYYY-MM-DDTHH:mm");
}

export function getTimeFromDate(time){
    const s = time.split("T");
    return s[1];
}

export function getDateFromDate(time){
    const s = time.split("T");
    return s[0];
}

/**
 * Calculates map bounds from 2 points
 *
 * @param p1
 * @param p2
 * @returns {{lat: *, lng: *}[]}
 */
export function calculateBounds(p1, p2) {
    const maxLat = p1.lat > p2.lat ? p1.lat : p2.lat;
    const minLat = p1.lat > p2.lat ? p2.lat : p1.lat;
    const maxLng = p1.lng > p2.lng ? p1.lng : p2.lng
    const minLng = p1.lng > p2.lng ? p2.lng : p1.lng;
    return [{ lat: maxLat, lng: maxLng }, { lat: minLat, lng: minLng }]
}

export function coordinatesToObj(coordinates) {
    const s = coordinates.split(",");
    return { lat: s[0], lng: s[1] };
}

export function concatIfExists(strToAdd) {
    return strToAdd + " " || "";
}

export function coordinates2addressQuery(coordinates, callback) {
    const query = {
        lat: coordinates.lat,
        lon: coordinates.lng,
        format: "json",
        addressdetails: 1,
    };

    axios.get(`https://nominatim.openstreetmap.org/reverse`, { params: query })
        .then(res => {
            Logger.log("got coordinates2address response");
            Logger.log(res)
            if (res.data.error) {
                const { msg } = res.data.error;
                Logger.log("but its error")
            } else {
                // handleResponse(res.data);
                if (callback && typeof (callback) === typeof (Function)) {
                    callback(res.data)
                }
            }
        }).catch(error => {
            // setErrorMessage("Error calling server");
        })
}

export function toDisplayAddress(result){
    return result.address.city + " " + concatIfExists(result.address.road) + concatIfExists(result.address.house_number) + "(" + result.osm_id + ")";
}

export function addItiIds(response) {
    // we are adding the ids to the itineraries to later use
    response.plan.itineraries.forEach(iti => {
        iti.id = generateId();
    })
    Logger.log("added ids to itineraries");
    Logger.log(response);
    return response;
}


/**
 * Simple method to generate 7 letter ID
 * @returns {string}
 */
export function generateId() {
    return Math.random().toString(36).substring(7)
}

export const defaultMapCenter = [50.270908, 19.039993];
export const defaultMapZoom = 15;
export const defaultMapZoomOnSelectPoint = 18;

